import { DiJava, DiJavascript1, DiReact } from 'react-icons/di';
import { SiMysql } from 'react-icons/si';

export const outerCircleIcons = [<DiJavascript1 />, <DiJava />, <DiReact />, <SiMysql />];

export const aboutMeData = [
  {
    title: 'Full Stack Developer',
    location: 'Currently living in Utrecht, Netherlands',
    descr:
      '4-year experience developing and implementing new software solutions. Experienced in all phases of the software development lifecycle, from concept to delivery. Consistently praised for being a hands-on, detail-oriented quick learner who is dedicated to his roles and deadlines.',
  },
];

export const aboutMeList = [
  {
    title: '5+',
    descr: 'Years of Experience',
  },
  {
    title: '12+',
    descr: 'Projects from Scratch',
  },
  {
    title: '200+',
    descr: 'Hours as an Instructor',
  },
];
